export enum IpassValidOptionLabels {
  YES = 'Yes',
  NO = 'No',
}
